/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {listSkills} from '../api'

export const useMutationListSkills = createReactQueryMutationHook('listSkills', listSkills)
